import {
  AccountBox as AccountBoxIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  Dashboard as DashboardIcon,
  Domain as DomainIcon,
  Error as ErrorIcon,
  Class as ClassIcon,
  VerifiedUser as VerifiedUserIcon,
  AssignmentLate as AssignmentLateIcon,
  LocalLibrary as LocalLibraryIcon,
  CardGiftcard as CardGiftcardIcon,
  Report as ReportIcon,
  RequestPageOutlined as RequestPageOutlinedIcon,
  ListAlt as ListAltIcon,
  Map as MapIcon,
  Person as PersonIcon,
  Group as GroupIcon,
  Timeline as TimelineIcon,
  InsertDriveFile as InsertDriveFileIcon,
  Description as DescriptionIcon,
  ViewListOutlined as ViewListOutlinedIcon,
  Category as CategoryIcon
} from '@material-ui/icons';

export interface NavigationItem {
  heading?: string;
  /** @deprecated Use `icon` instead. */
  iconEl?: JSX.Element;
  icon?: string;
  label?: string;
  path?: string;
  roles?: string[];
  excludeRoles?: string[];
  allowNoRoles?: boolean;
  items?: NavigationItem[];
}

export const navigationList: NavigationItem[] = [
  {
    iconEl: <DashboardIcon />,
    icon: 'dashboard',
    label: 'Dashboard',
    path: '/portal/dashboard',
    allowNoRoles: true
  },
  {
    iconEl: <ClassIcon />,
    icon: 'class',
    label: 'Training Admin',
    roles: ['Admin', 'SiteAdmin', 'TrainingAdmin'],
    items: [
      {
        label: 'Training Plans',
        roles: ['Admin', 'SiteAdmin', 'TrainingAdmin'],
        path: '/portal/admin/training'
      },
      {
        label: 'Trainees',
        roles: ['Admin', 'SiteAdmin', 'TrainingAdmin'],
        path: '/portal/admin/trainees'
      }
    ]
  },
  {
    iconEl: <MapIcon />,
    icon: 'map',
    label: 'Quality Roadmap',
    path: '/portal/quality-roadmap',
    roles: ['Admin', 'SiteAdmin']
  },
  // {
  //   icon: <VerifiedUserIcon />,
  //   label: 'My Training Log',
  //   path: '/portal/training-log',
  //   roles: ['Trainee']
  // },
  {
    iconEl: <VerifiedUserIcon />,
    icon: 'verified_user',
    label: 'Audit Management',
    path: '/portal/audit',
    roles: ['Admin', 'SiteAdmin']
  },
  {
    iconEl: <AssignmentLateIcon />,
    icon: 'assignment_late',
    label: 'Risk Management',
    path: '/portal/risk',
    roles: ['Admin', 'SiteAdmin', 'RiskAdmin']
  },
  {
    iconEl: <LocalLibraryIcon />,
    icon: 'local_library',
    label: 'Documents',
    path: '/portal/documents',
    roles: [
      'Admin',
      'SiteAdmin',
      'DocumentAdmin',
      'DocumentViewer',
      'DocumentEditor'
    ]
  },
  {
    iconEl: <CardGiftcardIcon />,
    icon: 'card_giftcard',
    label: 'Products',
    path: '/portal/products',
    roles: ['Admin', 'SiteAdmin', 'ProductAdmin']
  },
  // {
  //   icon: <LabelImportantIcon />,
  //   label: 'Document Board',
  //   path: '/portal/document-board',
  //   roles: ['Admin', 'DocumentEditor']
  // },
  {
    iconEl: <ErrorIcon />,
    icon: 'error',
    label: 'CAPA',
    path: '/portal/capa',
    roles: ['Admin', 'SiteAdmin', 'CapaAdmin']
  },
  {
    iconEl: <ReportIcon />,
    icon: 'report',
    label: 'SCAR',
    path: '/portal/scar',
    roles: ['Admin', 'SiteAdmin', 'ScarAdmin']
  },
  {
    iconEl: <RequestPageOutlinedIcon />,
    icon: 'request_page_outlined',
    label: 'Change Order',
    path: '/portal/change-order',
    roles: ['Admin', 'SiteAdmin', 'ChangeOrderAdmin']
  },
  {
    iconEl: <ListAltIcon />,
    icon: 'list_alt',
    label: 'JIRA',
    path: '/portal/jira',
    roles: ['Admin', 'SiteAdmin']
  },
  {
    iconEl: <DomainIcon />,
    icon: 'domain',
    label: 'Supplier Management',
    path: '/portal/suppliers',
    roles: ['Admin', 'SiteAdmin', 'SupplierAdmin']
  },
  {
    iconEl: <PersonIcon />,
    icon: 'person',
    label: 'Employees',
    path: '/portal/users',
    roles: ['Admin', 'SiteAdmin']
  },
  {
    iconEl: <GroupIcon />,
    icon: 'group',
    label: 'Teams',
    path: '/portal/groups',
    roles: ['Admin', 'SiteAdmin']
  },
  {
    iconEl: <AdminPanelSettingsIcon />,
    icon: 'admin_panel_settings',
    label: 'Roles',
    path: '/portal/roles',
    roles: ['Admin', 'SiteAdmin']
  },
  {
    iconEl: <ViewListOutlinedIcon />,
    icon: 'view_list_outlined',
    label: 'Forms',
    path: '/portal/admin/form-templates',
    roles: ['Admin']
  },
  {
    iconEl: <TimelineIcon />,
    icon: 'timeline',
    label: 'Workflow',
    path: '/portal/admin/workflow',
    roles: ['Admin', 'WorkflowAdmin']
  },
  {
    iconEl: <CategoryIcon />,
    icon: 'category',
    label: 'Task Types',
    path: '/portal/admin/task-types',
    roles: ['Admin', 'WorkflowAdmin']
  },
  {
    iconEl: <InsertDriveFileIcon />,
    icon: 'insert_drive_file',
    label: 'Templates',
    path: '/portal/admin/templates',
    roles: ['Admin', 'SiteAdmin']
  },
  {
    iconEl: <DescriptionIcon />,
    icon: 'description',
    label: 'Agreements',
    path: '/portal/admin/agreements',
    roles: ['Admin', 'SiteAdmin']
  },
  {
    iconEl: <AccountBoxIcon />,
    icon: 'account_box',
    label: 'Sign Up',
    path: '/portal/admin/signups',
    roles: ['Admin', 'SiteAdmin']
  }
];

export function filterNavigation(...labels: string[]): NavigationItem[] {
  return navigationList.filter((navigationItem: NavigationItem) => {
    return navigationItem.label && labels.includes(navigationItem.label);
  });
}
